module.exports = __webpack_public_path__ + "img/bg01.d07357c7.jpg";